import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Grid, Icon, IconColor, IconName, IconSize, } from '@as/cotopaxi';
import { BasketButtonError } from '@as-react/common-types';
import { Box, ConditionalWrapper, Label, Stack, TextAlpha, useMediaQueryMatchesOnDesktop, } from '@yonderland/andes-react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { PRODUCT_SIZE_CHIP_INNER_PADDING } from '../../../constants/ProductConstants';
import { getActiveSizeOptions, getSizeButtonsError, splitSizesBySizeAndLength } from '../../../util/ProductUtil';
import { ScrollUtil } from '../../../util/ScrollUtil';
export const SizeSelectButtonsSplitted = ({ type, id, selectedOption, setSelectedOption, lengthOptions, setLengthOptions, setSizeOptions, sizeOptions, isNotifyMeSizeError, options, filteredSizes, basketValidationState, selectedColorId, setFirstSelectedType, firstSelectedType, sizeCombinationNotExist, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const { sizesMap, lengthsMap } = splitSizesBySizeAndLength(filteredSizes);
    const [errorMessage, setErrorMessage] = useState();
    const isSize = type === 'size';
    const typeMap = isSize ? sizesMap : lengthsMap;
    const typeOptions = isSize ? sizeOptions : lengthOptions;
    const withNotifyMe = typeOptions.some(option => option.isNotifyMe);
    const chipSize = `${Math.max(...[...typeMap.keys()].map(s => s.length)) + (withNotifyMe ? 2 : 0)}ch + ${PRODUCT_SIZE_CHIP_INNER_PADDING + (withNotifyMe ? 4 : 0)}px`;
    const getSizeButtonState = (option, selected) => {
        if (errorMessage &&
            !option.disabled &&
            (!option.isNotifyMe || (!option.isSoldOut && isNotifyMeSizeError)) &&
            !selectedOption) {
            return 'error';
        }
        if (option.label === selected) {
            return 'activated';
        }
        return 'enabled';
    };
    const handleButtonClick = (option) => () => {
        setErrorMessage(undefined);
        setSelectedOption(option.label.toString());
        if (!firstSelectedType) {
            setFirstSelectedType(type);
        }
        const updatedOptions = getActiveSizeOptions(typeMap.get(option.label.toString()) || [], options, isSize ? lengthOptions : sizeOptions, isSize ? 'length' : 'size');
        if (isSize) {
            setLengthOptions(updatedOptions);
        }
        else {
            setSizeOptions(updatedOptions);
        }
    };
    useEffect(() => {
        setErrorMessage(undefined);
    }, [selectedColorId]);
    useEffect(() => {
        if ((basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT ||
            basketValidationState === BasketButtonError.SKU ||
            isNotifyMeSizeError) &&
            !selectedOption) {
            ScrollUtil.scrollToErrorElement(document.getElementById(id), isDesktop, () => setErrorMessage(getSizeButtonsError(basketValidationState, type)));
        }
    }, [basketValidationState, selectedOption, isNotifyMeSizeError, sizeCombinationNotExist]);
    const buttonOptions = useMemo(() => typeOptions.map(option => (_jsx(Chip, { state: getSizeButtonState(option, selectedOption), text: _jsxs(ConditionalWrapper, { condition: Boolean(type !== firstSelectedType && ((option.isSoldOut && option.isNotifyMe) || option.disabled)), wrapper: children => (_jsx(TextAlpha, { as: "span", strike: true, variant: "inherit", children: children })), children: [option.label, ' ', option.isNotifyMe && type !== firstSelectedType && (_jsx(Icon, { name: IconName.EMAIL, color: "N300", size: IconSize.MINOR, inline: true }))] }, option.label), onClick: handleButtonClick(option), noInlinePadding: true }, option.label))), [options, sizeOptions, lengthOptions, errorMessage]);
    return (_jsxs(Box, { id: id, testId: id, paddingBlockEnd: "6", children: [_jsx(Label, { children: t(`pdp.size.buttons.${type}`) }), _jsx(Box, { paddingBlock: "2", children: _jsx(Grid, { scalable: {
                        min: `calc(${chipSize})`,
                        maxCols: typeOptions.length <= 2 ? { mobile: 2, desktop: 3 } : { mobile: 4, desktop: 6 },
                        repeatPattern: typeOptions.length <= 2 ? 'auto-fill' : undefined,
                    }, gap: "s", dataQA: `${type}-select-buttons`, children: buttonOptions }) }), errorMessage && (_jsxs(Stack, { children: [_jsx(Icon, { name: IconName.INFORMATION_OUTLINE, color: IconColor.NEGATIVE }), ' ', _jsx(TextAlpha, { as: "span", color: "error", children: t(errorMessage) })] }))] }));
};
